export default __webpack_public_path__ + "static/shape-a834dc01241d82b7529d4193f8b48e76.gif";